import React from "react";
import "./CompleteMessage.css";

const CompleteMessage = ({ type, icon, message }) => {
  const isUserMessage = type === "user";

  return (
    <div className={`main-message ${isUserMessage ? "user-align" : "server-align"}`}>
      {isUserMessage ? (
        <>
          <div className="message-content">{message}</div>
          <div className="user-icon-div">{icon}</div>
        </>
      ) : (
        <>
          <div className="server-icon-div">{icon}</div>
          <div className="message-content">{message}</div>
        </>
      )}
    </div>
  );
};

export default CompleteMessage;
